import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { BrandService } from '../../../business-services/brand.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CookieService } from 'ngx-cookie-service';
import { BrandViewModel } from '../../../business-entities/brand-view-model';
import { DeletedPlanningService } from '../../../business-services/deleted-panning.service';
import { DeletedPlanningModel, DeletedPlanningRequestModel } from '../../../business-entities/delete-planning-model';
import { PagerData } from '../../../business-entities/PagerData';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Filter } from '../../../business-entities/Filter';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { PaginationService } from '../../../services/pagination.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
@Component({
  selector: 'app-deleted-planning',
  templateUrl: './deleted-planning.component.html'

})
export class DeletedPlanningComponent implements OnInit {
  licensePlateClass: string;
  brandList: BrandViewModel[];
  requestModel: DeletedPlanningRequestModel = {
    startRecordNumber: 0,
    numberOfRecord: 25,
    sortColumn: '',
    sortDirection: '',
    languageCode: null,
    searchTerm: null,
    isExport:false
  };
  deletedPlanningList: DeletedPlanningModel[] = [];
  deletedPlanningExcelList: DeletedPlanningModel[] = [];
  totalCount: number = 0;
  pager: any = {};
  pagerData: PagerData = {
    page: 1,
    pagerSize: Constant.GridPagerSize,
  };
  searchTerm: string;
  pagedItems: any[];
  scrollDistance = 1;
  throttle = 100;
  dataRows: any[] = [];
  filterItems: any[];
  filter: Filter = new Filter();
  dataList: DeletedPlanningModel[] = [];

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    private globalSetting: GlobalSetting,
    private brandService: BrandService,
    private spinner: NgxSpinnerService,
    private cookieservice: CookieService,
    private service: DeletedPlanningService,
    private pagerService: PaginationService,
    private currentLanguageService: CurrentLanguage,
    private excelService: ExcelService,
    private translate: TranslateService,
    private toaster: ToastrService,

  ) { }

  ngOnInit(): void {
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.getBrands().then(() => {
      this.getDeletedPlanningList();
    });
  }
  public getBrands(): Promise<void> {
    return new Promise((resolve, _reject) => {
      this.brandService.getBrand().then((res) => {
        if (res) {
          this.brandList = res;
        }
        resolve();
      });
    });
  }
  getBrandImage(key: any) {
    return this.brandList?.filter(
      (x) => x.brandCode.toUpperCase() === key.toUpperCase()
    )[0];
  }
  async getDeletedPlanningList() {
    this.spinner.show();
    try {
      this.currentLanguageService.currentLanguage.subscribe(async x => {
        this.requestModel.languageCode = x;
      })
      this.service.getDeletedPlanningList(this.requestModel).then(
        (res) => {
          if ( res == null) {
            //this is intentional;
          }
          else {
            this.deletedPlanningList.push(...res);
            this.deletedPlanningList.forEach((element) => {
              element.logo = element.brand
                ? this.getBrandImage(element.brand)
                : null;
            })

            this.totalCount =
              this.deletedPlanningList.length > 0
                ? this.deletedPlanningList[0].totalCount
                : 0;
            this.resetPagerData(
              this.supplierInitiliseGridFromServer(
                this.deletedPlanningList,
                this.totalCount
              )
            );
            if (this.pagerData.page > 1) {
              this.resetPagerData(
                this.initilisePagerFromServer(
                  this.pagerData.page,
                  this.pagerData.pagerSize,
                  this.totalCount
                )
              );
            }
          }
          setTimeout(() => {
            this.spinner.hide();
          }, 2000);
          this.spinner.hide();
        }
      );
    }
    catch {
      this.spinner.hide();
    }
  }
  onQuickSerch() {
    this.deletedPlanningList = [];
    this.requestModel.startRecordNumber = 0;
    this.requestModel.searchTerm = this.searchTerm;
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    this.getDeletedPlanningList();
  }

  clearFilter() {
    this.searchTerm = null;
    this.requestModel.searchTerm = null;
    this.requestModel.startRecordNumber = 0;
    this.deletedPlanningList = [];
    this.getDeletedPlanningList();
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }
  async setPage(pagerData: PagerData) {
    if (
      pagerData == null ||
      pagerData === undefined ||
      pagerData.page < 1 ||
      pagerData.page > this.pager.totalPages
    ) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
  }
  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.requestModel.sortColumn = column;
    this.requestModel.sortDirection = direction;
    this.requestModel.startRecordNumber = 0;
    this.deletedPlanningList = [];
    this.getDeletedPlanningList();
  }

  onScrollDown() {
    if (this.totalCount > this.deletedPlanningList?.length) {
      this.requestModel.startRecordNumber = this.deletedPlanningList.length
      this.getDeletedPlanningList();
    }
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  // Export functionality

  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();  
    this.spinner.hide();
    this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblDeletedPlanning')}`);
  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const pdfData = this.mapDataForExport();
    const doc = new jsPDF('landscape');
    autoTable(doc, {
      head: [this.getHeadersForExport()],
      body: pdfData.map(row => Object.values(row)),
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8 },
      columnStyles: {
        0: { cellWidth: 8 },
        1: { cellWidth: 20 },
        2: { cellWidth: 20 },
        3: { cellWidth: 20 },
        4: { cellWidth: 30 },
        5: { cellWidth: 25 },
        6: { cellWidth: 40 },
        8: { cellWidth: 30 },
        9: { cellWidth: 30 },
        10: { cellWidth: 28 },
      }
    });
    doc.save(`${this.translate.instant('lblDeletedPlanning')}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
    this.spinner.show();
    this.requestModel.isExport = true;
    await this.service.getDeletedPlanningList(this.requestModel).then((res) => {
      if (!res || res == null) {
        this.toaster.error(this.translate.instant('lblDataNotAvailable'));
        this.dataList = [];
        return;
      }
      this.dataList = res;
    }).finally(() => {
      this.requestModel.isExport = false;
      this.spinner.hide();
    })
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblWoNo')]: item.workorderNo,
      [this.translate.instant('lblRegNumber')]: item.licensePlate,
      [this.translate.instant('lblBrandCode')]: item.brand,
      [this.translate.instant('lblModel')]: item.model,
      [this.translate.instant('lblWoStatus')]: item.workOrderStatus,
      [this.translate.instant('lblCustomerName')]: `${item.customerName}\n${item.mobileNo ? `+${item.mobileCode} ${item.mobileNo}` : ''}`,
      [this.translate.instant('lblMechanic')]: item.mechanicName,
      [this.translate.instant('lblDeletedBy')]: item.deletedBy,
      [this.translate.instant('lblDeletedDate')]: item.deletedDate ? new Date(item.deletedDate).toLocaleString() : '',
      [this.translate.instant('lblReason')]: item.reason,
    }));
  }

  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblWoNo'),
      this.translate.instant('lblRegNumber'),
      this.translate.instant('lblBrandCode'),
      this.translate.instant('lblModel'),
      this.translate.instant('lblWoStatus'),
      this.translate.instant('lblCustomerName'),
      this.translate.instant('lblMechanic'),
      this.translate.instant('lblDeletedBy'),
      this.translate.instant('lblDeletedDate'),
      this.translate.instant('lblReason'),
    ];
  }
}